'use client';

export default function Footer() {
  return (
    <footer className="mt-auto py-3 bg-light border-top">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <small className="text-muted">
              Copyright©2025 NTT Corp. All Rights Reserved.
            </small>
          </div>
        </div>
      </div>
    </footer>
  );
}
